<template>
    <div class="edit_item_list">
        <div class="scroll_box">
            <div class="flex_box">

                <div class="item_wrapper"
                     v-for="item in sorted_image_list"
                     :key="item.id"
                     :class="{now_editing: (item.id === editing_id)}"
                     @click="selectItem(item.id)"
                     @dblclick="setModal('SelectItem')"
                >

                    <div v-if="item.image_config" class="item">
                        <p class="text">
                            <span>{{getItemTypeInJapanese(item.item_type)}}</span>
                        </p>
                        <p class="img"><img :src="getPath(item)" alt="thumbnail"></p>
                        <p class="text">
                            <span>{{(item.item_data && item.item_data.name) || item.id}}</span>
                        </p>
                    </div>

                    <div v-else class="item note">
                        商品を<br>選択してください
                    </div>

                </div>


            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
    import CONST from '../../assets/js/const'

    export default {
        name: "EditItemList",
        data: () => ({
            img_base_url: `${process.env.VUE_APP_BASE_URL}item_image`,
        }),
        computed: {
            ...mapState('simulator', ['editing_id']),
            ...mapGetters('simulator', ['sorted_image_list']),
        },
        methods: {
            ...mapMutations(['setModal']),
            ...mapMutations('simulator', ['createNewItem']),
            ...mapActions(["resetTimer"]),
            ...mapActions('simulator', ["setEditingId"]),
            selectItem(id) {
                this.setEditingId(id);
                this.resetTimer();
            },
            getPath(item) {
                if (!item.item_data || !item.item_type) return './assets/images/unnamed.png';
                return `${this.img_base_url}/${item.item_type}/thumbnail/${item.item_data.name}.jpg?version=2.0`
            },
            getItemTypeInJapanese(item_type) {
                switch (item_type) {
                    case CONST.ITEM_TYPE_CURTAIN : { return 'カーテン'}
                    case CONST.ITEM_TYPE_WALL    : { return '壁紙' }
                    case CONST.ITEM_TYPE_FLOOR   : { return '床材' }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";
    $item_width: 100px;

    .edit_item_list{
        .add_item{
            @extend .clickable;
            width: $item_width;
            min-height: 140px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: #2F5597;
            color: white;
            font-size: 12px;
            .text{
                width: $item_width;
                text-align: center;
            }
        }
        .item_wrapper {
            box-sizing: border-box;
            border: #aaa solid 1px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &.now_editing{
                background-color: #DAE3F3;
            }
            .item{
                @extend .clickable;
                box-sizing: border-box;
                text-align: center;
                padding: 0 0.5rem;
                position: relative;
                width: $item_width;
                p{ margin: 0 }
                img{
                    width: 100%;
                    vertical-align: middle;
                }
                .text{
                    text-align: center;
                    padding: 0.3rem 0;
                }
                &.note{
                    font-size: 12px;
                    line-height: 1.8;
                }
            }
        }
    }

    .scroll_box{
        background-color: white;
        border: #707070 solid 1px;
        padding: 0.5rem 0;
        overflow-y: hidden;
        overflow-x: auto;
        display: flex;
        .flex_box{
            display: flex;
            align-items: stretch;
            flex-wrap: nowrap;
            &:first-child{ margin-left: 1rem }
            > *{ margin-right: 0.5rem }
            > div.add_item{ margin-right: 1rem }
        }
    }
</style>
